import React from 'react'

import { FileMaganerSection } from '../../Common'
import { Box, Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const FilesAttachmentStep = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        // Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    const {formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        handleClickReturnStep,
        handleClickNextStep
    } = Actions

    return (
        <>
            <FileMaganerSection useFetchInit={useFetchInit} />
            <div className="pt-4"></div>
            <Box className="text-center" sx={{mt: 2}}>
                <Button 
                    startIcon={<ArrowLeftCircle/>}
                    variant="outlined"
                    type="button" 
                    className='btn-round'
                    color='warning'
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 1, marginLeft: 1 }}
                >
                    Volver
                </Button>

                {(formOpeningMode==='EDITABLE') && (
                    <Button
                        endIcon={<ArrowRightCircle/>}
                        variant="outlined"
                        className='btn-round'
                        color='warning'
                        type='button'
                        onClick={handleClickNextStep}
                        sx={{ marginRight: 1, marginLeft: 1 }}
                    >
                        Continuar
                    </Button>
                )} 
            </Box>
        </>
        
    )
}
